import axiosClient from "../../../../axiosClient"

export default async (data) => {
    const result = await axiosClient.post("/invalidate-candidate-saved-form-structure", data)

    return result.data
}
